import React, { useEffect, useRef, useState } from 'react';

import * as Footer from './Footer.jsx';
import * as Header from './Header.jsx';
import { HomeLinkV1 } from './HomeLink.jsx';
import { default as Image } from '../common/Image.jsx';
import Layout from '../common/Layout.jsx';
import { SubscribeFormV1 } from '../block/SubscribeForm.jsx';

// region Footer

function LegacyFooter(props) {
    const config = props.config || {};
    let layout = config.layout;
    if (layout) {
        layout = layout.toLowerCase();
    }

    let Component;
    switch (layout) {
        case Layout.Type.Theme.Arizona:
            Component = _FooterArizona;
            break;
        case Layout.Type.Theme.Classic:
            Component = _FooterClassic;
            break;
        case Layout.Type.Theme.Francisco:
            Component = _FooterFrancisco;
            break;
        case Layout.Type.Theme.Mariana:
            Component = _FooterMariana;
            break;
        case Layout.Type.Theme.Nashville:
            Component = _FooterNashville;
            break;
        case Layout.Type.Theme.Novara:
            Component = _FooterNovara;
            break;
        case Layout.Type.Theme.Piedmont:
            Component = _FooterPiedmont;
            break;
        case Layout.Type.Theme.Sydney:
            Component = _FooterSydney;
            break;
    }
    if (!Component) {
        return null;
    }
    return <Component {...props} />
}

function _FooterArizona(props) {
    return (
        <footer className="foot--main">
            <div className="cont cont--spaced cont--spaced--lg">
                <div className="cont__row">
                    <div className="foot--main__row">
                        <div className="foot__title">
                            <span className="foot__title__text">Get in touch</span>
                        </div>
                        <div className="foot--main__anch__cont">
                            <Footer.Address.Component {...props} type="legacy" />
                        </div>
                    </div>
                    <div className="foot--main__row">
                        <div className="foot__title">
                            <span className="foot__title__text">Quick Links</span>
                        </div>
                        <Footer.QuickLinks.Component {...props} type="legacy" />
                    </div>
                    <div className="foot--main__row foot--inputs">
                        <div className="foot__title">
                            <span className="foot__title__text">Subscribe</span>
                        </div>
                        <SubscribeFormV1.Component {...props} />
                    </div>
                </div>
            </div>
            <div className="cont text--cent social__outer">
                <Footer.CustomContent {...props} appendNewline={true} className="foot__copy foot__custom" />
                <div className="cont__foot--bottom">
                    <div className="social__anch__cont">
                        <Footer.Social.Component {...props} type="legacy" />
                    </div>
                    <p className="foot__copy">
                        <Footer.Copyright {...props} type="legacy" />
                    </p>
                </div>
            </div>
        </footer>
    );
}

function _FooterClassic(props) {
    return (
        <footer className="foot--main">
            <div className="cont cont--spaced cont--spaced--lg">
                <div className="cont__row">
                    <div className="foot--main__row">
                        <div className="foot__title">
                            <span className="foot__title__text">Get in touch</span>
                        </div>
                        <div className="foot--main__anch__cont">
                            <Footer.Address.Component {...props} type="legacy" />
                        </div>
                    </div>
                    <div className="foot--main__row">
                        <div className="foot__title">
                            <span className="foot__title__text">Quick Links</span>
                        </div>
                        <Footer.QuickLinks.Component {...props} type="legacy" />
                    </div>
                    <div className="foot--main__row foot--inputs">
                        <div className="foot__title">
                            <span className="foot__title__text">Subscribe</span>
                        </div>
                        <SubscribeFormV1.Component {...props} />
                    </div>
                </div>
            </div>
            <div className="cont text--cent">
                <Footer.CustomContent {...props} appendNewline={true} className="foot__copy foot__custom" />
                <div className="cont__foot--bottom">
                    <div className="social__anch__cont">
                        <Footer.Social.Component {...props} type="legacy" />
                    </div>
                    <p className="foot__copy">
                        <Footer.Copyright {...props} type="legacy" />
                    </p>
                </div>
            </div>
        </footer>
    );
}

function _FooterFrancisco(props) {
    return (
        <footer className="foot--main">
            <div className="cont">
                <Footer.CustomContent {...props} className="cont__row" />
            </div>
            <p className="foot__copy">
                <Footer.Copyright {...props} type="legacy" />
            </p>
        </footer>
    );
}

function _FooterMariana(props) {
    return (
        <footer className="foot--simp">
            <div className="cont">
                <div className="foot--simp__inn">
                    <div className="foot--simp__left">
                        <Footer.Address.Component {...props} simple={true} type="legacy" />
                    </div>
                    <div className="foot--simp__right">
                        <div className="social__anch__cont">
                            <Footer.Social.Component {...props} type="legacy" />
                        </div>
                    </div>
                </div>
                <Footer.CustomContent {...props} className="foot__copy foot__custom" />
                <p className="foot__copy">
                    <Footer.Copyright {...props} type="legacy" />
                </p>
            </div>
        </footer>
    );
}

function _FooterNashville(props) {
    useEffect(() => {
        // Home page settings
        if ($('.home-page').length > 0) {
            $('.home-page').parents('.cont').addClass('cont--full-width');
            $('.nav--main').addClass('nav--abs');
            $('.search--main').addClass('search--abs');
        }

        const animateCards = function (elemClass) {
            var wTop = $(window).scrollTop();
            var wHeight = $(window).height();
            var wBottom = wTop + wHeight;
            $(elemClass).each(function (id, el) {
                var elem = $(el);
                var parent = elem.parent();
                var cTop = elem.offset().top;
                var cHeight = elem.height();
                var cBottom = cTop + cHeight;
                var pastContent = cBottom < wTop;
                var futureContent = cTop > wBottom;
                var presentContent = !pastContent && !futureContent;
                if (presentContent && !parent.hasClass('animate__card--present')) {
                    parent.removeClass('animate__card--future');
                    parent.removeClass('animate__card--past');
                    parent.addClass('animate__card--present');
                }
                if (pastContent && !parent.hasClass('animate__card--past')) {
                    parent.removeClass('animate__card--present');
                    parent.addClass('animate__card--past');
                }
                if (futureContent && !parent.hasClass('animate__card--future')) {
                    parent.removeClass('animate__card--present');
                    parent.addClass('animate__card--future');
                }
            });
        }
        const selector = '.cell--whitelabel--artist';
        $(window).scroll(function () {
            animateCards(selector);
            animateCards('.artist__card');
        });

        animateCards(selector);
        animateCards('.artist__card');
    }, []);

    const config = props.config || {};
    let logoImageUrl = '';
    if (config.logo) {
        logoImageUrl = Image.url(config.logo);
    }
    return (
        <React.Fragment>
            <footer className="foot--main">
                <div className="cont foot--main__cont">
                    <div className="foot--main__row">
                        <Footer.CustomContent {...props} className="foot--main__text foot__custom" />
                    </div>
                    <div className="social__anch__cont">
                        <Footer.Social.Component {...props} type="legacy" />
                    </div>
                    <p className="foot__copy">
                        <Footer.Copyright {...props} type="legacy" />
                    </p>
                </div>
            </footer>
        </React.Fragment>
    );
}

function _FooterNovara(props) {
    return (
        <footer className="foot--main">
            <div className="cont cont--spaced cont--spaced--lg">
                <div className="cont__row">
                    <div className="foot--main__row">
                        <div className="foot__title">
                            <span className="foot__title__text">About</span>
                        </div>
                        <Footer.CustomContent {...props} className="foot--main__text foot__custom" />
                        <div className="foot--main__anch__cont">
                            <Footer.Address.Component {...props} type="legacy" />
                        </div>
                        <div className="social__anch__cont">
                            <Footer.Social.Component {...props} type="legacy" />
                        </div>
                    </div>
                    <div className="foot--main__row">
                        <div className="foot__title">
                            <span className="foot__title__text">Quick Links</span>
                        </div>
                        <Footer.QuickLinks.Component {...props} type="legacy" />
                    </div>
                    <div className="foot--main__row foot--inputs">
                        <div className="foot__title">
                            <span className="foot__title__text">Subscribe</span>
                        </div>
                        <SubscribeFormV1.Component {...props} />
                    </div>
                </div>
            </div>
            <p className="foot__copy">
                <Footer.Copyright {...props} type="legacy" />
            </p>
        </footer>
    );
}

function _FooterPiedmont(props) {
    return (
        <footer className="foot--simp">
            <div className="cont">
                <div className="foot--simp__inn">
                    <div className="foot--simp__left">
                        <Footer.Address.Component {...props} simple={true} type="legacy" />
                    </div>
                    <div className="foot--simp__right">
                        <div className="social__anch__cont">
                            <Footer.Social.Component {...props} type="legacy" />
                        </div>
                    </div>
                </div>
                <Footer.CustomContent {...props} className="foot__copy foot__custom" />
                <p className="foot__copy">
                    <Footer.Copyright {...props} type="legacy" />
                </p>
            </div>
        </footer>
    );
}

function _FooterSydney(props) {
    const config = props.config || {};
    return (
        <footer className="foot--main">
            <div className="cont text--cent">
                <Footer.CustomContent {...props} appendNewline={true} className="foot__copy foot__custom" />
            </div>
            <div className="cont cont--spaced cont--spaced--lg">
                <div className="cont__row">
                    <div className="foot--main__row">
                        <div className="foot__copy">
                            <div className="foot__logo__cont body-bkg">
                                <HomeLinkV1.Component {...props} footer={true} />
                            </div>
                            <p>
                                <Footer.Copyright {...props} type="legacy" /> &nbsp;&nbsp;&nbsp; {config.addressLineOne} &nbsp;&nbsp;&nbsp; {config.addressLineTwo} &nbsp;&nbsp;&nbsp; {config.location} &nbsp;&nbsp;&nbsp; {config.country} &nbsp;&nbsp;&nbsp; {config.phone}
                            </p>
                        </div>
                        <div className="social__anch__cont">
                            <Footer.Social.Component {...props} type="legacy" />
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    );
}

// region Header

function LegacyHeader(props) {
    const config = props.config || {};
    let layout = config.layout;
    if (layout) {
        layout = layout.toLowerCase();
    }

    let Component;
    switch (layout) {
        case Layout.Type.Theme.Arizona:
            Component = _HeaderArizona;
            break;
        case Layout.Type.Theme.Classic:
            Component = _HeaderClassic;
            break;
        case Layout.Type.Theme.Francisco:
            Component = _HeaderFrancisco;
            break;
        case Layout.Type.Theme.Mariana:
            Component = _HeaderMariana;
            break;
        case Layout.Type.Theme.Nashville:
            Component = _HeaderNashville;
            break;
        case Layout.Type.Theme.Novara:
            Component = _HeaderNovara;
            break;
        case Layout.Type.Theme.Piedmont:
            Component = _HeaderPiedmont;
            break;
        case Layout.Type.Theme.Sydney:
            Component = _HeaderSydney;
            break;
    }
    if (!Component) {
        return null;
    }

    // Mobile Nav Menu
    const [mobileNavVisible, setMobileNavVisible] = useState(false);

    // Search Bar
    const refSearchBar = useRef(undefined);
    const [searchBarVisible, setSearchBarVisible] = useState(false);
    const handleSearchToggle = function () {
        const visible = !searchBarVisible;
        setSearchBarVisible(visible);
        if (!visible || !refSearchBar.current) {
            return;
        }
        refSearchBar.current.focus();
    }
    const hasHomePage = Layout.hasTypedPage(config, Layout.Type.Page.Home);
    const menuItems = <Header.MenuItems.Component {...props} type="legacy" />
    return (
        <Component
            {...props}
            menuItems={menuItems}
            mobileNavVisible={mobileNavVisible}
            searchBarRef={refSearchBar}
            searchBarVisible={searchBarVisible}
            onMobileToggle={setMobileNavVisible}
            onSearchToggle={handleSearchToggle}>
            <Header.NavMobile
                baseUrl={props.baseUrl}
                builder={props.builder}
                config={props.config}
                hasHomePage={hasHomePage}
                queryDataSub={props.queryDataSub}
                queryLayout={props.queryLayout}
                querySub={props.querySub}
                visible={mobileNavVisible} />
        </Component>
    );
}

function _HeaderArizona(props) {
    useEffect(() => {
        // sets search row fixed under nav with larger logo sizes
        $('.search--row').css('top', $('.nav--main').height() + 'px');

        // sets padding for slider and content with bigger logo sizes
        $('.arizona').css('padding-top', $('.nav--main').height() + 'px');
    }, []);

    return (
        <React.Fragment>
            {props.children}
            <div className="nav nav--fixed nav--row nav--main">
                <div className="cont">
                    <HomeLinkV1.Component
                        baseUrl={props.baseUrl}
                        builder={props.builder}
                        config={props.config}
                        queryDataSub={props.queryDataSub}
                        queryLayout={props.queryLayout}
                        querySub={props.querySub} />
                    <Header.MobileToggle.Component
                        builder={props.builder}
                        type="legacy"
                        onToggle={props.onMobileToggle} />
                    <div className="nav__menu">
                        {props.menuItems}
                        <Header.SearchToggle.Component builder={props.builder} onClick={props.onSearchToggle} />
                        <Header.CartLink.Component builder={props.builder} config={props.config} />
                    </div>
                    <Header.SearchToggle.Component
                        builder={props.builder}
                        type="legacy"
                        onClick={props.onSearchToggle} />
                    <Header.CartLink.Component
                        builder={props.builder}
                        config={props.config}
                        type="legacy" />
                </div>
            </div>
            <Header.SearchBar
                baseUrl={props.baseUrl}
                builder={props.builder}
                dataSub={props.queryDataSub}
                layout={props.queryLayout}
                legacy={true}
                sub={props.querySub}
                type="theme"
                visible={props.searchBarVisible}
                onRef={props.searchBarRef} />
        </React.Fragment>
    );
}

function _HeaderClassic(props) {
    return (
        <React.Fragment>
            {props.children}
            <div className="nav nav--main nav--row">
                <div className="cont">
                    <HomeLinkV1.Component
                        baseUrl={props.baseUrl}
                        builder={props.builder}
                        config={props.config}
                        queryDataSub={props.queryDataSub}
                        queryLayout={props.queryLayout}
                        querySub={props.querySub} />
                    <Header.MobileToggle.Component
                        builder={props.builder}
                        type="legacy"
                        onToggle={props.onMobileToggle} />
                    <div className="nav__menu">
                        {props.menuItems}
                        <Header.SearchToggle.Component builder={props.builder} onClick={props.onSearchToggle} />
                        <Header.CartLink.Component builder={props.builder} config={props.config} />
                    </div>
                    <Header.SearchToggle.Component
                        builder={props.builder}
                        type="legacy"
                        onClick={props.onSearchToggle} />
                    <Header.CartLink.Component
                        builder={props.builder}
                        config={props.config}
                        type="legacy" />
                </div>
            </div>
            <Header.SearchBar
                baseUrl={props.baseUrl}
                builder={props.builder}
                dataSub={props.queryDataSub}
                layout={props.queryLayout}
                legacy={true}
                sub={props.querySub}
                type="theme"
                visible={props.searchBarVisible}
                onRef={props.searchBarRef} />
        </React.Fragment>
    );
}

function _HeaderFrancisco(props) {
    useEffect(() => {
        if ($('.drop__anch--active').siblings('.drop__inn').length > -1) {
            $('.drop__anch--active').parent().addClass('drop--active');
        }
    }, []);

    return (
        <React.Fragment>
            {props.children}
            <div className="nav nav--main nav--fixed">
                <div className="cont">
                    <div className="nav__logo__cont">
                        <HomeLinkV1.Component
                            baseUrl={props.baseUrl}
                            builder={props.builder}
                            config={props.config}
                            queryDataSub={props.queryDataSub}
                            queryLayout={props.queryLayout}
                            querySub={props.querySub} />
                    </div>
                    <Header.MobileToggle.Component
                        builder={props.builder}
                        type="legacy"
                        onToggle={props.onMobileToggle} />
                    <div className="nav__menu">
                        {props.menuItems}
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
}

function _HeaderMariana(props) {
    return (
        <React.Fragment>
            {props.children}
            <div className="nav nav--row nav--cent">
                <Header.MobileToggle.Component
                    builder={props.builder}
                    type="legacy"
                    onToggle={props.onMobileToggle} />
                <div className="nav__menu">
                    {props.menuItems}
                    <Header.SearchToggle.Component builder={props.builder} onClick={props.onSearchToggle} />
                    <Header.CartLink.Component builder={props.builder} config={props.config} />
                </div>
                <Header.SearchToggle.Component
                    builder={props.builder}
                    type="legacy"
                    onClick={props.onSearchToggle} />
                <Header.CartLink.Component
                    builder={props.builder}
                    config={props.config}
                    type="legacy" />
                <HomeLinkV1.Component
                    baseUrl={props.baseUrl}
                    builder={props.builder}
                    config={props.config}
                    queryDataSub={props.queryDataSub}
                    queryLayout={props.queryLayout}
                    querySub={props.querySub} />
            </div>
            <Header.SearchBar
                baseUrl={props.baseUrl}
                builder={props.builder}
                dataSub={props.queryDataSub}
                layout={props.queryLayout}
                legacy={true}
                sub={props.querySub}
                type="theme"
                visible={props.searchBarVisible}
                onRef={props.searchBarRef} />
        </React.Fragment>
    );
}

function _HeaderNashville(props) {
    return (
        <React.Fragment>
            {props.children}
            <div className="nav nav--main">
                <div className="cont nav__cont">
                    <HomeLinkV1.Component
                        baseUrl={props.baseUrl}
                        builder={props.builder}
                        config={props.config}
                        queryDataSub={props.queryDataSub}
                        queryLayout={props.queryLayout}
                        querySub={props.querySub} />
                    <div className="nav__menu__cont">
                        <div className="nav__menu">
                            {props.menuItems}
                            <Header.SearchToggle.Component builder={props.builder} onClick={props.onSearchToggle} />
                            <Header.CartLink.Component builder={props.builder} config={props.config} />
                        </div>
                        <Header.SearchToggle.Component
                            builder={props.builder}
                            type="legacy"
                            onClick={props.onSearchToggle} />
                        <Header.CartLink.Component
                            builder={props.builder}
                            config={props.config}
                            type="legacy" />
                        <Header.MobileToggle.Component
                            builder={props.builder}
                            type="legacy"
                            onToggle={props.onMobileToggle} />
                    </div>
                </div>
            </div>
            <Header.SearchBar
                baseUrl={props.baseUrl}
                builder={props.builder}
                className="search--abs"
                dataSub={props.queryDataSub}
                layout={props.queryLayout}
                legacy={true}
                sub={props.querySub}
                type="theme"
                visible={props.searchBarVisible}
                onRef={props.searchBarRef} />
        </React.Fragment>
    );
}

function _HeaderNovara(props) {
    return (
        <React.Fragment>
            {props.children}
            <div className="nav nav--main">
                <div className="cont">
                    <HomeLinkV1.Component
                        baseUrl={props.baseUrl}
                        builder={props.builder}
                        config={props.config}
                        queryDataSub={props.queryDataSub}
                        queryLayout={props.queryLayout}
                        querySub={props.querySub} />
                    <Header.MobileToggle.Component
                        builder={props.builder}
                        type="legacy"
                        onToggle={props.onMobileToggle} />
                    <div className="nav__menu">
                        {props.menuItems}
                        <Header.SearchToggle.Component builder={props.builder} onClick={props.onSearchToggle} />
                        <Header.CartLink.Component builder={props.builder} config={props.config} />
                    </div>
                    <Header.SearchToggle.Component
                        builder={props.builder}
                        type="legacy"
                        onClick={props.onSearchToggle} />
                    <Header.CartLink.Component
                        builder={props.builder}
                        config={props.config}
                        type="legacy" />
                </div>
            </div>
            <Header.SearchBar
                baseUrl={props.baseUrl}
                builder={props.builder}
                dataSub={props.queryDataSub}
                layout={props.queryLayout}
                legacy={true}
                sub={props.querySub}
                type="theme"
                visible={props.searchBarVisible}
                onRef={props.searchBarRef} />
        </React.Fragment>
    );
}

function _HeaderPiedmont(props) {
    useEffect(() => {
        const setSearchRowPosition = () => {
            // sets search row fixed under nav with larger logo sizes
            $('.sect--slider .search--row').css({
                'top': $('.nav').outerHeight() + 'px',
                'position': 'absolute'
            });
        }
        setSearchRowPosition();

        $(window).on('resize', setSearchRowPosition);
    }, []);

    return (
        <React.Fragment>
            {props.children}
            <div className="nav nav--main">
                <div className="cont">
                    <HomeLinkV1.Component
                        baseUrl={props.baseUrl}
                        builder={props.builder}
                        config={props.config}
                        queryDataSub={props.queryDataSub}
                        queryLayout={props.queryLayout}
                        querySub={props.querySub} />
                    <Header.MobileToggle.Component
                        builder={props.builder}
                        type="legacy"
                        onToggle={props.onMobileToggle} />
                    <div className="nav__menu">
                        {props.menuItems}
                        <Header.SearchToggle.Component builder={props.builder} onClick={props.onSearchToggle} />
                        <Header.CartLink.Component builder={props.builder} config={props.config} />
                    </div>
                    <Header.SearchToggle.Component
                        builder={props.builder}
                        type="legacy"
                        onClick={props.onSearchToggle} />
                    <Header.CartLink.Component
                        builder={props.builder}
                        config={props.config}
                        type="legacy" />
                </div>
            </div>
            <Header.SearchBar
                baseUrl={props.baseUrl}
                builder={props.builder}
                dataSub={props.queryDataSub}
                layout={props.queryLayout}
                legacy={true}
                sub={props.querySub}
                type="theme"
                visible={props.searchBarVisible}
                onRef={props.searchBarRef} />
        </React.Fragment>
    );
}

function _HeaderSydney(props) {
    return (
        <React.Fragment>
            {props.children}
            <div className="nav nav--main nav--row">
                <div className="cont">
                    <div className="nav__logo__cont body-bkg">
                        <HomeLinkV1.Component
                            baseUrl={props.baseUrl}
                            builder={props.builder}
                            config={props.config}
                            queryDataSub={props.queryDataSub}
                            queryLayout={props.queryLayout}
                            querySub={props.querySub} />
                    </div>
                    <Header.MobileToggle.Component
                        builder={props.builder}
                        type="legacy"
                        onToggle={props.onMobileToggle} />
                    <div className="nav__menu">
                        {props.menuItems}
                        <Header.SearchToggle.Component builder={props.builder} onClick={props.onSearchToggle} />
                        <Header.CartLink.Component builder={props.builder} config={props.config} />
                    </div>
                    <Header.SearchToggle.Component
                        builder={props.builder}
                        type="legacy"
                        onClick={props.onSearchToggle} />
                    <Header.CartLink.Component
                        builder={props.builder}
                        config={props.config}
                        type="legacy" />
                </div>
            </div>
            <Header.SearchBar
                baseUrl={props.baseUrl}
                builder={props.builder}
                dataSub={props.queryDataSub}
                layout={props.queryLayout}
                legacy={true}
                sub={props.querySub}
                type="theme"
                visible={props.searchBarVisible}
                onRef={props.searchBarRef} />
        </React.Fragment>
    );
}

export {
    LegacyFooter as Footer,
    LegacyHeader as Header
};